<template>
  <main>
    <Works>
      <div>
        <div class="row">
          <WorksImageContainer
            class="col"
            :caption="project.Captions[0]"
            :imageSource="imageSourceStr(project.Title, 0)"
          />
        </div>
        <div class="row">
          <WorksImageContainer
            class="col-9-xs col-md"
            :caption="project.Captions[1]"
            :imageSource="imageSourceStr(project.Title, 1)"
          />
          <WorksImageContainer
            class="col-9-xs col-md"
            :caption="project.Captions[2]"
            :imageSource="imageSourceStr(project.Title, 2)"
          />
        </div>
        <div class="row">
          <WorksImageContainer
            class="col-9-xs col-md"
            :caption="project.Captions[3]"
            :imageSource="imageSourceStr(project.Title, 3)"
          />
          <WorksImageContainer
            class="col-9-xs col-md"
            :caption="project.Captions[4]"
            :imageSource="imageSourceStr(project.Title, 4)"
          />
        </div>
        <div class="row">
          <WorksImageContainer
            class="col"
            :caption="project.Captions[5]"
            :imageSource="imageSourceStr(project.Title, 5)"
          />
        </div>
        <div class="row">
          <WorksImageContainer
            class="col-9-xs col-md"
            :caption="project.Captions[6]"
            :imageSource="imageSourceStr(project.Title, 6)"
          />
          <WorksImageContainer
            class="col-9-xs col-md"
            :caption="project.Captions[7]"
            :imageSource="imageSourceStr(project.Title, 7)"
          />
        </div>
        <div class="row">
          <WorksImageContainer
            class="col"
            :caption="project.Captions[8]"
            :imageSource="imageSourceStr(project.Title, 8)"
          />
        </div>
      </div>
    </Works>
  </main>
</template>

<script>
import Works from "@/components/Works.vue";
import WorksImageContainer from "@/components/WorksImageContainer.vue";
// import WorksVideoContainer from "@/components/WorksVideoContainer.vue";

export default {
  name: "TurningStool",
  components: {
    Works,
    WorksImageContainer,
    // WorksVideoContainer
  },
  computed: {
    project() {
      return this.$store.state.activeProject;
    }
  },
  methods: {
    imageSourceStr: function(title, idx) {
      let str = title.replace(/[^\w\d]/g, "");
      str += "/" + str + idx;
      return str;
    }
  },
  beforeCreate: function() {
    this.$store.commit("setSelected", 5);
  }
};
</script>
